var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBluetoothLe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15V13.5H15.5V9H14V15H18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15H23V13.75H20.5V12.64H23V11.38H20.5V10.26H23V9H19V15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.71 7.71L8 2H7V9.59L2.41 5L1 6.41L6.59 12L1 17.59L2.41 19L7 14.41V22H8L13.71 16.29L9.41 12L13.71 7.71ZM9 5.83L10.88 7.71L9 9.59V5.83ZM10.88 16.29L9 18.17V14.41L10.88 16.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBluetoothLe);
export default __webpack_public_path__ + "static/media/icon-bluetooth-le.adf4274d47d95b7c405ead8efa8e93f8.svg";
export { ForwardRef as ReactComponent };